// extracted by mini-css-extract-plugin
export default {"goButton":"SelectFolder_goButton__2e7iZ"};